export const UNITS = Object.freeze({
    KILOGRAM: 0,
    GRAM: 1,
    LITER: 2,
    MILLILITER: 3,
});

export const UNITS_ENUM = Object.freeze({
    [UNITS.KILOGRAM]: 'кл',
    [UNITS.GRAM]: 'г',
    [UNITS.LITER]: 'л',
    [UNITS.MILLILITER]: 'мл',
});

export const UNIT_CODE = Object.freeze({
    UNIT: 0,
    GRAM: 10,
    KILOGRAM: 11,
    NONE: 255
});

export const UNIT_CODE_TITLE = Object.freeze({
    [UNIT_CODE.UNIT]: 'шт',
    [UNIT_CODE.GRAM]: 'г',
    [UNIT_CODE.KILOGRAM]: 'кг',
    [UNIT_CODE.NONE]: '',
});
